export default "__VITE_ASSET__DqhLuUJ6__"